import type { SidebarNavItem } from "@pericles/framework-frontend";

export interface NavigationItem {
  id: string;
  label: string;
  labelKey?: string;
  route: string;
  icon?: string;
  screenId?: string;
  children?: NavigationItem[];
}

export interface NavigationGroup {
  id: string;
  label: string;
  items: NavigationItem[];
}

export const navigationConfig: NavigationGroup[] = [
  {
    id: "modules",
    label: "Modules",
    items: [
      {
        id: "longwalls",
        label: "LongWalls",
        route: "/longwalls",
        children: [
          {
            id: "longwalls-milestones",
            label: "Milestones",
            route: "/milestones",
          },
        ],
      },
      {
        id: "accounts",
        label: "Agora",
        labelKey: "nav.agora",
        route: "/accounts",
        screenId: "customers_list",
      },
      {
        id: "atlas",
        label: "Atlas",
        labelKey: "nav.atlas",
        route: "/atlas",
      },
      {
        id: "foundry",
        label: "Foundry",
        labelKey: "nav.foundry",
        route: "/foundry",
      },
      {
        id: "forum",
        label: "Forum",
        labelKey: "nav.forum",
        route: "/forum",
      },
      {
        id: "jarvis",
        label: "Jarvis",
        labelKey: "nav.jarvis",
        route: "/jarvis",
        children: [
          {
            id: "runtime-cockpit",
            label: "Runtime Cockpit",
            route: "/runtime-cockpit",
          },
        ],
      },
      {
        id: "aegis",
        label: "Governance",
        labelKey: "nav.governance",
        route: "/governance",
      },
    ],
  },
];

const mapNavItem = (item: NavigationItem, translate: (label: string) => string): SidebarNavItem => ({
  id: item.id,
  label: translate(item.labelKey ?? item.label),
  href: item.route,
  icon: item.icon,
  screenId: item.screenId,
  children: item.children?.map((child) => mapNavItem(child, translate)),
});

export const buildSidebarNavFromConfig = (
  groups: NavigationGroup[] = navigationConfig,
  translate: (label: string) => string = (label) => label,
): SidebarNavItem[] => groups.flatMap((group) => group.items.map((item) => mapNavItem(item, translate)));
